import { render, staticRenderFns } from "./LeadsListItem.vue?vue&type=template&id=75831820&scoped=true&"
import script from "./LeadsListItem.vue?vue&type=script&lang=js&"
export * from "./LeadsListItem.vue?vue&type=script&lang=js&"
import style0 from "./LeadsListItem.vue?vue&type=style&index=0&id=75831820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75831820",
  null
  
)

export default component.exports